/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext } from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import { DocumentContext } from "~context/DocumentContext";
import Button from "~components/Button";
import CollectionShelf from "~components/CollectionShelf";
import Footer from "~components/Footer";
import GradientBorder from "~components/GradientBorder";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import { sortArrayByPriority } from "~utils/helpers";

const CollectionsPage = ({ data, location }) => {
  const { device } = useContext(DocumentContext);

  //

  const cms = data.sanityCollectionIndex;

  //

  const brands = [];

  data.allSanityBrand.edges.forEach(({ node }) => {
    brands.push(node);
  });

  sortArrayByPriority(brands);

  //

  const collections = [];

  data.allSanityCollection.edges.forEach(({ node }) => {
    collections.push(node);
  });

  sortArrayByPriority(collections);

  //

  return (
    <>
      <SEO
        customTitle={cms?.title}
        customDescription={cms?.seoDescription}
        customKeywords={cms?.seoKeywords}
        path={location.pathname}
      />

      <Layout className="collections-page w-full relative pt-v7 bg-bone">
        <section className="product-grid w-full relative pt-8 md:pt-0 bg-bone text-black">
          <div className="grid">
            <header
              className={`animation-appear-down-slow animation-delay-1 grid-end-12 md:grid-end-8 md:grid-start-3 relative ${
                device === `desktop` ? `pt-v4` : `pt-8 pb-4`
              } flex flex-col items-center justify-center text-center`}
            >
              <h2 className="f2">{cms.brandsHeading}</h2>

              <h3
                className={`${
                  device === `desktop` ? `mt-v1 mb-v2` : `mt-4 mb-6 px-2`
                } b2`}
              >
                {cms.brandsIntro}
              </h3>

              <Button color={`${device === `desktop` ? `white` : `orange`}`}>
                <Link to="/brands" className="block f-button pr-10 pl-10">
                  Shop all Brands
                </Link>
              </Button>
            </header>
          </div>

          <ul
            className={`animation-appear-right-slow animation-delay-4 grid items-stretch ${
              device === `desktop` ? `pt-v4 pb-v2` : `pb-12`
            }`}
          >
            {brands?.[0] &&
              brands.map((brand, brandIndex) => {
                const key = `${brand.title}-${brandIndex}`;

                //

                return (
                  <li
                    key={key}
                    className={`product-grid__item grid-end-6 md:grid-end-3 relative flex flex-col items-stretch ${
                      device === `desktop`
                        ? `mb-v4 pr-v05 pl-v05`
                        : `mt-3 mb-5 ${brandIndex % 2 === 0 ? `pr-1` : `pl-1`}`
                    }`}
                  >
                    <Link to={`/brands/${brand.handle}`}>
                      <div className="product-grid__item__image relative overflow-hidden bg-light-bone">
                        <figure className="w-full h-full absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center">
                          <Img
                            className="w-full h-full relative block object-cover"
                            fluid={brand.image.asset.fluid}
                            alt={brand.title}
                          />
                        </figure>
                      </div>
                    </Link>

                    <Link
                      to={`/brands/${brand.handle}`}
                      className={`w-full relative block ${
                        device === `desktop` ? `mt-v1` : `mt-2 mb-2`
                      }`}
                    >
                      {(device === `desktop` && (
                        <Button className="w-full relative block" color="white">
                          <span className="f-button">View {brand.title}</span>
                        </Button>
                      )) || (
                        <div className="w-full h-8 relative flex items-center justify-center border-black bg-white text-black">
                          <span className="caption">Shop {brand.title}</span>
                        </div>
                      )}
                    </Link>
                  </li>
                );
              })}
          </ul>

          <GradientBorder />
        </section>

        {collections.map((collection, collectionIndex) => {
          return (
            <section
              key={collection.title}
              className="animation-appear-down-slow"
              style={{ animationDelay: `${collectionIndex * 100 + 100}ms` }}
            >
              <CollectionShelf collection={collection} />
            </section>
          );
        })}
      </Layout>

      <Footer />
    </>
  );
};

export default CollectionsPage;

export const query = graphql`
  query CollectionsPage {
    sanityCollectionIndex {
      title
      seoDescription
      seoKeywords

      brandsHeading
      brandsIntro
    }

    allSanityBrand {
      edges {
        node {
          title
          handle
          priority
          image {
            asset {
              fluid {
                ...GatsbySanityImageFluid_noBase64
              }
            }
            altText
          }
        }
      }
    }

    allSanityCollection {
      edges {
        node {
          title
          priority
          handle
          description
        }
      }
    }
  }
`;
